export const PermissionType: {
  CHECKBOX: string;
  E_SIGN: string;
  SMS: string;
} = {
  CHECKBOX: "checkbox",
  E_SIGN: "signature",
  SMS: "SMS",
};

export enum AuthType {
  E_SIGN = "signature",
  SMS = "SMS",
}

export interface IAuthContinue {
  signature?: string;
  enableContinue: boolean;
}
